export default __webpack_public_path__ + "static/media/Blooded Bracers of the Everlasting Sky.e08305f6.jpg";